import axios from 'axios'

const api = axios.create({
  baseURL: 'https://api.consultantaachizitii.ro/api/',
  withCredentials: false
})

export default api
